import React, { Component } from 'react'

export default class Footer extends Component {
  render() {
    return (
      <div className="footer">
        <h1 id="footWords" className="text-center">Brisk Cleaning Service | Central Texas</h1>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Footer.js